// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { xBaseTheme } from "@awc/XDL/types";
import { getSystemColor } from "@awc/XDL/Utilities";
import { css } from "styled-components";

const sharedNestedListStyles = `
    padding: 0 20px;
    margin: 0;
    & ul, & ol {
        margin: 16px 0;
    }
`;

export default {
    defaultProps: {
        css: css`
            ul,
            ol {
                padding: 0 20px;
                margin: 0;
            }
        `,
    },
    unorderedListProps: {
        css: css`
            ${sharedNestedListStyles}
        `,
    },
    orderedListProps: {
        css: css`
            & ol {
                list-style-type: lower-alpha;
            }
            ${sharedNestedListStyles}
        `,
    },
    listItemProps: {
        css: css`
            color: ${getSystemColor("text.main")};
            font-size: ${fontConfig.fontSize.regular}px;
            line-height: 22px;
            margin: 0 0 16px 0;
        `,
    },
} as xBaseTheme["lists"];
